/**
 * 
 * key
 * 
 */


const key = 'c2F2ZXRoZXBob3Rv'

export default key 